import React, {useCallback, useEffect, useState} from "react";
import DsModal from "../_UI/dsModal";
import Form from "../_UI/dsModal/form.module.scss";
import {useDispatch, useSelector} from "react-redux";

import {getDepositLink, getDepositLinkFailure, setWalletBuyModalStatus} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";
import ftfIcon from "../../theme/assets/redesign/wallet/token_ftf.webp";



const CabinetWalletBuyModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const walletBuyModalStatus = useSelector(store => store.cabinet.walletBuyModalStatus);
    const depositLinkStatus = useSelector(store => store.cabinet.depositLinkStatus);
    const depositLinkStatusErr = useSelector(store => store.cabinet.depositLinkStatusErr);



    const [amount, setAmount] = useState('');

    const closeModal = useCallback(() => {
        dispatch(setWalletBuyModalStatus(false));
        setAmount('');
    }, [dispatch]);

    const mainBtnHandler = () =>{
        dispatch(getDepositLink({amount: amount}))
    }

    const onChangeAmount = (e) => {
        let v = e.target.value;
        v = v.replace(/[^\d.,]/g, "");
        const p = v.indexOf(".") >= 0 ? v.indexOf(".") : v.indexOf(",");
        if (p >= 0) v = v.slice(0, p + 1) + v.slice(p + 1).replace(/[.,]/g, "");
        v = v.replace(/^(\d+[.,]?)(\d{0,2}).*$/, "$1$2");

        setAmount(v);
    };

    useEffect(() => {
        if (depositLinkStatus){
            window.open(depositLinkStatus?.url, "_blank");
            closeModal();
        }
    }, [depositLinkStatus, closeModal]);

    const canConfirm = Number(String(amount).replace(',', '.')) > 0;

    return (
        <DsModal
            open={walletBuyModalStatus}
            onClose={closeModal}
            title={t('Пополнить баланс')}
        >
            <div className={Form.field}>
                <div className={Form.label}>{t('Введите сумму')}</div>
                <div className={`${Form.inputBox} ${depositLinkStatusErr?.amount ? Form.inputBoxErr : ''}`}>
                    <input
                        type="text"
                        value={amount}
                        inputMode="decimal"
                        placeholder="0"
                        pattern="[0-9]*[.,]?[0-9]{0,2}"
                        onChange={onChangeAmount}
                        autoFocus
                        onKeyDown={() => {
                            if (depositLinkStatusErr?.amount) {
                                const next = {...depositLinkStatusErr};
                                delete next.amount;
                                dispatch(getDepositLinkFailure(next));
                            }
                        }}
                    />
                    <span className={Form.suffix}>
                        <img src={ftfIcon} alt=""/>
                        FTF
                    </span>
                </div>
                <div className={Form.err}>{depositLinkStatusErr?.amount ? depositLinkStatusErr.amount : null}</div>
            </div>
            <button
                type="button"
                className={`${Form.btnAccent} ${canConfirm ? '' : Form.btnDisabled}`}
                onClick={mainBtnHandler}
            >
                {t('Подтвердить')}
            </button>
        </DsModal>
    );
};

export default CabinetWalletBuyModal;
